module.exports = __webpack_public_path__ + "img/avatar.71dc1238.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar.jpg
// module id = odpv
// module chunks = 1